// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj, generateHeaders } from '..'
import { vcBaseUrl } from '.'


export type PromoResponse = (SuccessResponse & {
    promo: {
        id: string
        type: string
        action: string
        amount: number
        createdAt: string
        updatedAt: string
        expiresAt: string
        canClaim?: boolean
        requirements?: {
            groupSpend?: number
            participantCount?: number
        }
        user?: {
            id: string
            givenName: string
            familyName: string
        }
    }
}) | FailedResponse

export class GetPromoRequest extends Request {
    private constructor(promoId: string, init?: RequestInit) { 
        super(`${vcBaseUrl}/promo/${promoId}`, init) 
    }
    
    /**
     * @param promoId - The promo ID to fetch
     * @param authenticated - If true, includes auth token (needed for canClaim response)
     */
    static async init(promoId: string, authenticated: boolean = false, init?: RequestInit) {
        const headers = authenticated 
            ? await generateHeaders('Clerk-Token', init?.headers)
            : new Headers({ 'Content-Type': 'application/json' })
        
        return new GetPromoRequest(promoId, {
            ...init,
            method: 'GET',
            headers,
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<PromoResponse> {
        const response = await fetch(this)
        const data = createResponseObj<PromoResponse>(await response.json())
        console.info("Get Promo Response:", data)
    
        switch (data.status) {
            case 'successful': return data
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}
